export default __webpack_public_path__ + "static/media/actividad-37.b34071b4.mp3";